import {StyleSheet} from 'aphrodite';

import {HELP_TOOLTIP_STYLE} from 'processes/ProcessConstants';
import {GRAY_DARK} from 'ui-library/Colors';

export const MAX_TASK_SCHEMA_NAME_LENGTH = 150;

export const sharedStyles = StyleSheet.create({
  checkboxWrapper: {
    width: '100%',
  },
  checkboxField: {
    lineHeight: '28px',
  },
  messageText: {
    paddingTop: 4,
    color: GRAY_DARK,
    fontSize: '13px',
    lineHeight: '16px',
  },
  input: {
    flex: 1,
  },
  helpTooltip: HELP_TOOLTIP_STYLE,
});
